import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { REQUEST_ID_HEADER, requestId } from '../shared/request-id';

/**
 * Interceptor to add a request id to the request headers if not already present
 * Generates a new request id if not present and adds it to the request headers
 * Only adds header for requests to the API domain to avoid CORS issues with external APIs
 * @param req Request
 * @param next Next handler
 * @returns Observable
 */
export function requestIdInterceptor(req: HttpRequest<any>, next: HttpHandlerFn) {
  // Skip adding header for external domains (e.g., WordPress CMS)
  const isApiRequest = req.url.startsWith(environment.crowdAPIURL);

  if (!isApiRequest) {
    return next(req);
  }

  let outRequest = req;
  let id = req.headers.get(REQUEST_ID_HEADER);

  if (!id) {
    id = requestId();

    outRequest = req.clone({
      headers: req.headers.set(REQUEST_ID_HEADER, id),
    });
  }

  return next(outRequest).pipe(
    catchError((error: unknown) => {
      (error as Record<string, string>)['requestId'] = id;

      // TODO: Sentry error reporting

      return throwError(() => error);
    })
  );
}
